// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"740":"312d31f5","884":"abd4a127","906":"56ce731b"}[chunkId] + ".css";
};